import React from 'react';
import Head from 'next/head';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';

import { serverURL } from '../config';
import Layout from '../src/components/Layout/Layout';
import Content from '../src/components/Content/Content';

const fetcher = (url) => fetch(url).then((res) => res.json());

const AliasPage = ({ response, error }) => {
  const router = useRouter();
  const { preview, alias } = router.query;
  const userId = response.user_id;

  if (!response) {
    return (
      <Layout>
        <div>
          <h2>404 Page Not Found</h2>
          <h3>Sorry this Technician&amp;s Page was not found. Please try to find another Technician</h3>
          <p>{JSON.stringify(error)}</p>
        </div>
      </Layout>
    );
  }

  return (
    <>
      <Head>
        <title>{response.title}</title>
        <meta name="description" content={response.description} />
        <meta property="og:title" content={response.title} />
        <meta property="og:description" content={response.description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`https://${serverURL}/${alias}`} />
        <link rel="canonical" href={`https://${serverURL}/${alias}`} />
        {response.logo_url
          && <meta property="og:image" content={response.logo_url} />}
      </Head>
      <Layout preview={preview === 'true'} userId={userId}>
        <Content data={response} preview={preview === 'true'} />
      </Layout>
    </>
  );
};

AliasPage.propTypes = {
  response: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    logo_url: PropTypes.string,
    user_id: PropTypes.number,
  }),
  error: PropTypes.object,
};

export async function getServerSideProps({ query }) {
  try {
    let queryString = '';
    const { authorization, timestamp, userId } = query;

    if (authorization && timestamp && userId) {
      queryString = `?authorization=${authorization}&userId=${userId}&timestamp=${timestamp}`;
    }

    const response = await fetcher(`${serverURL}/api/mysite/${query.alias}${queryString}`);

    if (response.status === 200) {
      return { props: { response } };
    }
    return {
      notFound: true
    };
  } catch {
    return {
      notFound: true
    };
  }
}

export default AliasPage;
